import ShipBobAuthentication from '@shipbob/auth';
import { ENV } from '../env';

let localAuthService = null;

export function getAuthService() {
  if (localAuthService) {
    return localAuthService;
  }

  localAuthService = new ShipBobAuthentication({
    authority: ENV.VUE_APP_AUTH_AUTHORITY,
    client_id: ENV.VUE_APP_CLIENT_ID,
    post_logout_redirect_uri: `${location.protocol}//${location.host}/`,
    redirect_uri: `${location.protocol}//${location.host}/signin-callback`,
    response_type: 'code',
    scope: ENV.VUE_APP_CLIENT_SCOPE
  });
  return localAuthService;
}